export function getInitials(fullName: string): string {
	const fullNameSplit = fullName
		.trim()
		.split(' ')
		.filter((value) => value.length > 0)
		.map((value) => value[0]);

	return fullNameSplit.slice(0, 2).join('').toUpperCase();
}
